angular.module('leanlaw').controller('MatterAssignCtrl', ['$scope', '$state', 'alerts', 'leanLawApi', function ($scope, $state, alerts, leanLawApi) {
  $scope.saving = false;
  $scope.error = false;
  $scope.assign = assign;
  $scope.merge = merge;
  activate();

  ///////////////////////////////////

  function activate() {
    leanLawApi.listClients({
      scope: 'all',
      matters: 'include'
    }).then(list => {
      $scope.clients = list.clients;
      $scope.$parent.$watch('matter', () => {
        if (!$scope.matter || !$scope.matter.stats) return;
        $scope.newClient = $scope.matter.client;
        $scope.newMatter = $scope.matter;
        $scope.deleteClient = false;
        const client = $scope.clients.find(c => $scope.matter.client.id === c.id);
        $scope.matters = client.matters;
      });
    });
  }
  function merge(matter) {
    leanLawApi.mergeMatters({
      dest: matter.id,
      src: $scope.matter.id
    }).then(matter => {
      done();
    }).catch(alerts.error);
  }
  function assign(client) {
    leanLawApi.updateMatter({
      id: $scope.matter.id,
      body: {
        client: {
          id: client.id
        }
      }
    }).then(matter => {
      if ($scope.deleteClient) {
        return leanLawApi.deleteClient({
          id: $scope.matter.client.id
        }).then(() => {
          done();
        });
      }
      done();
    }).catch(alerts.error);
  }
  function done() {
    // Feature-flagged route (sc-46278): see the same check in
    // matter.info.ctrl.js's delete/activateClient.
    $state.go($scope.me.features?.fizzyLiftingDrink ? 'matters' : 'matters-next', {}, {
      reload: true
    });
  }
}]);